var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5868_9803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3589 5H8.46922C6.55631 5 5 6.55631 5 8.46922V15.3589C5 17.2718 6.55631 18.8281 8.46922 18.8281H15.3589C17.2718 18.8281 18.8281 17.2718 18.8281 15.3589V8.46922C18.8281 6.55631 17.2718 5 15.3589 5ZM16.4844 15.3589C16.4844 15.9795 15.9795 16.4844 15.3589 16.4844H8.46922C7.84865 16.4844 7.34375 15.9795 7.34375 15.3589V8.46922C7.34375 7.84865 7.84865 7.34375 8.46922 7.34375H15.3589C15.9795 7.34375 16.4844 7.84865 16.4844 8.46922V15.3589Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4844 5H24.6875C22.749 5 21.1719 6.57711 21.1719 8.51562V15.3125C21.1719 17.251 22.749 18.8281 24.6875 18.8281H31.4844C33.4229 18.8281 35 17.251 35 15.3125V8.51562C35 6.57711 33.4229 5 31.4844 5ZM32.6562 15.3125C32.6562 15.9587 32.1305 16.4844 31.4844 16.4844H24.6875C24.0413 16.4844 23.5156 15.9587 23.5156 15.3125V8.51562C23.5156 7.86945 24.0413 7.34375 24.6875 7.34375H31.4844C32.1305 7.34375 32.6562 7.86945 32.6562 8.51562V15.3125Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3589 21.1719H8.46922C6.55631 21.1719 5 22.7282 5 24.6411V31.5308C5 33.4437 6.55631 35 8.46922 35H15.3589C17.2718 35 18.8281 33.4437 18.8281 31.5308V24.6411C18.8281 22.7282 17.2718 21.1719 15.3589 21.1719ZM16.4844 31.5308C16.4844 32.1513 15.9795 32.6562 15.3589 32.6562H8.46922C7.84865 32.6562 7.34375 32.1513 7.34375 31.5308V24.6411C7.34375 24.0205 7.84865 23.5156 8.46922 23.5156H15.3589C15.9795 23.5156 16.4844 24.0205 16.4844 24.6411V31.5308Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4844 21.1719H24.6875C22.749 21.1719 21.1719 22.749 21.1719 24.6875V31.4844C21.1719 33.4229 22.749 35 24.6875 35H31.4844C33.4229 35 35 33.4229 35 31.4844V24.6875C35 22.749 33.4229 21.1719 31.4844 21.1719ZM32.6562 31.4844C32.6562 32.1305 32.1305 32.6562 31.4844 32.6562H24.6875C24.0413 32.6562 23.5156 32.1305 23.5156 31.4844V24.6875C23.5156 24.0413 24.0413 23.5156 24.6875 23.5156H31.4844C32.1305 23.5156 32.6562 24.0413 32.6562 24.6875V31.4844Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5868_9803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIconBlue);
export default __webpack_public_path__ + "static/media/grid_icon_blue.50300a125763b2f6833bdb1f59633058.svg";
export { ForwardRef as ReactComponent };